import { useRecoilValue } from 'recoil';

import { timezoneState } from 'components/common/Managers/PreferencesManager.state';

export const useTimezone = () => useRecoilValue(timezoneState);
